var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"base-button-container"},[_c('BaseIcon',{staticClass:"back-button-icon",attrs:{"icon":"chevron-left-dark","height":20,"width":20}}),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('general_back')))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }